import { render } from "./content-header.vue?vue&type=template&id=2d400c96&scoped=true"
import script from "./content-header.vue?vue&type=script&lang=js"
export * from "./content-header.vue?vue&type=script&lang=js"

import "./content-header.vue?vue&type=style&index=0&id=2d400c96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d400c96"]])

export default __exports__